/* tslint:disable:max-line-length */
export var getInterfaceWrongDomainErrorMsg = function getInterfaceWrongDomainErrorMsg() {
  return 'Interface domain is not provided or has wrong type!';
};
export var getInterfaceNoMethodsErrorMsg = function getInterfaceNoMethodsErrorMsg(interfaceName) {
  return "Interface ".concat(interfaceName, " does not have any methods or events defined!");
};
export var getMethodTooManyArgsErrorMsg = function getMethodTooManyArgsErrorMsg(methodName) {
  return "Service method ".concat(methodName, " has too many arguments!");
};
export var getMethodUnexpectedArgsErrorMsg = function getMethodUnexpectedArgsErrorMsg(domain, serviceName, methodName) {
  return " Unexpected arguments number for ".concat(domain, ".").concat(serviceName, ".").concat(methodName, "!");
};
export var getMetaMissingFunctionsErrorMsg = function getMetaMissingFunctionsErrorMsg(serviceName, objName, missingFunctions) {
  return "Invalid service ".concat(serviceName, " metadata: ").concat(objName, " is missing ").concat(missingFunctions.join(', '), " functions");
};
//# sourceMappingURL=errorMessages.js.map